import Vue from 'vue'
import Vuex from 'vuex'

import login from './modules/auth/login'
import categories from './modules/app/categories/categories'
import products from './modules/app/products/products'
import tags from './modules/app/tags/tags'
import mobileLayout from './modules/app/mobileLayout/mobileLayout'
import slides from './modules/app/slides/slides'
import banner from './modules/app/banner/banner'
import productDesign from './modules/app/mobileLayout/productDesign'
import * as getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
   state: {  
    token: localStorage.getItem('user-token') || '',
    user: localStorage.getItem('user-role'),
    loading: true,
  },
  getters,
  modules: {
    login,
    categories,
    products,
    tags,
    mobileLayout,
    productDesign,
    slides,
    banner
  }
})
